import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BusyService {
  busyRequestCount =0;
  constructor(private spinnerService: NgxSpinnerService) { }

  notify:Subject<boolean> = new Subject<boolean>();
  
  onNotify(event: boolean){
    this.notify.next(event)
  }

  busy() {
    this.busyRequestCount++;
    this.onNotify(true)
    this.spinnerService.show(undefined, {
      type: 'line-scale-party',
      bdColor: 'rgba(255,255,255,0)',
      color: '#333333'
    });
  }
  idle() {
    this.busyRequestCount--;
    this.onNotify(false)
    if(this.busyRequestCount <=0 ) {
      this.spinnerService.hide();
    }
  }
}

